import axiosInstance from 'src/utils/axios';
import * as Types from './types.api';

//
//

const EXTEND_URL = '/purchases/v1/';
const PURCHASE_BY_QUOTE_URL = EXTEND_URL + 'quote';

//

export const getPurchaseByIdAPI = async (
  query: Types.PurchaseByIdQuery
): Promise<Types.PurchaseByIdResponse> => {
  const { id, customerFullName } = query;

  const response = await axiosInstance.get<Types.PurchaseByIdResponse>(
    `${EXTEND_URL}${id}${customerFullName ? '?fields=customerFullName' : ''}`
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

//

export const startPurchaseByQuoteAPI = async (data: Types.StartPurchaseByQuoteData) => {
  return axiosInstance.post(`${EXTEND_URL}quote/start`, data, {});
};

//

export const createPurchaseByQuoteAPI = async (data: Types.CreatePurchaseByQuoteQueryParams) => {
  try {
    const response = await axiosInstance.post(PURCHASE_BY_QUOTE_URL, data, {});
    return response?.data;
  } catch (error) {
    console.error('Failed to make a purchase by quote:', error);
    throw error;
  }
};

export const createInvoiceRequestAPI = async (data: Types.CreateInvoiceQueryParams) => {
  return axiosInstance.post(`${EXTEND_URL}invoice/quote`, data, {});
};

export const linkBusinessCustomerAPI = async (payload: Types.LinkBusinessCustomerPayload) => {
  const { purchaseId, businessCustomerId } = payload;

  return axiosInstance.patch(
    `${EXTEND_URL}${purchaseId}`,
    JSON.stringify({ businessCustomerId: businessCustomerId })
  );
};
